import { DateTime } from 'luxon';

/**
 * Sininho de erro de integração da Lista de Pedidos.
 *
 * O alerta vale só do dia em que entrou no ar em diante: os erros antigos já
 * foram tratados (ou abandonados) e só encheriam o sino de ruído. Continuam
 * aparecendo na lista pelo filtro "Situação".
 */
export const INICIO_ALERTA_ERRO_INTEGRACAO = '2026-09-29';

export function pedidoComErroIntegracao(pedido: any): boolean {
  return String(pedido?.situacao || '').trim().toUpperCase() === 'ERRO_INTEGRACAO';
}

/** Dia da emissão no fuso do navegador, em `YYYY-MM-DD` (data_emissao é timestamptz). */
function diaDaEmissao(pedido: any): string {
  const quando = DateTime.fromISO(String(pedido?.data_emissao || ''));
  return quando.isValid ? quando.toISODate() || '' : '';
}

/**
 * Os pedidos que o sino mostra, do mais recente para o mais antigo. Quando o
 * erro é resolvido e o pedido integra, a situação muda e ele sai sozinho.
 */
export function errosIntegracaoDoAlerta(
  pedidos: any[],
  desde: string = INICIO_ALERTA_ERRO_INTEGRACAO
): any[] {
  return (Array.isArray(pedidos) ? pedidos : [])
    .filter((p) => pedidoComErroIntegracao(p) && diaDaEmissao(p) >= desde)
    .sort(
      (a, b) =>
        DateTime.fromISO(String(b?.data_emissao || '')).toMillis() -
        DateTime.fromISO(String(a?.data_emissao || '')).toMillis()
    );
}

// Quais erros a pessoa já abriu pelo sino — por usuário, porque o computador
// da logística costuma ser compartilhado. localStorage pode estar bloqueado
// (aba anônima, política do navegador): aí o sino só não lembra, não quebra.
const chaveVistos = (usuarioId: string) => `@Aplication:errosIntegracaoVistos:${usuarioId}`;

export function lerErrosVistos(usuarioId: string): Set<string> {
  try {
    const salvo = JSON.parse(localStorage.getItem(chaveVistos(usuarioId)) || '[]');
    return new Set(Array.isArray(salvo) ? salvo : []);
  } catch {
    return new Set();
  }
}

/**
 * Grava os vistos guardando só os que ainda estão com erro: pedido que já
 * integrou não volta para o sino, então lembrar dele só incharia a chave.
 */
export function salvarErrosVistos(usuarioId: string, vistos: Set<string>, pendentes: any[]): void {
  const ainda = new Set(pendentes.map((p) => p?.pedido_id));
  try {
    localStorage.setItem(
      chaveVistos(usuarioId),
      JSON.stringify(Array.from(vistos).filter((id) => ainda.has(id)))
    );
  } catch {}
}
